$(document).ready(function () {
  // Initialize animations when DOM is ready
  initAnimations();

  // Throttle scroll event for better performance
  let scrollTimeout;
  $(window).on("scroll", function () {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(function () {
        handleScroll();
        scrollTimeout = null;
      }, 10);
    }
  });

  // Handle initial state
  handleScroll();
});

$(window).on("load", () => {
  // Refresh animations after all resources loaded
  handleScroll();
});

// Store last scroll position to determine direction
let lastScrollTop = 0;

/**
 * Handle all scroll-based effects
 */
function handleScroll() {
  const scrollTop = $(window).scrollTop();
  const windowHeight = $(window).height();
  const triggerPoint = windowHeight * 0.95; // Trigger at 75% of viewport

  // Determine scroll direction
  const scrollingDown = scrollTop > lastScrollTop;
  lastScrollTop = scrollTop;

  // Header transformation
  if (scrollTop > 30) {
    $(".site-header").addClass("scrolled");
  } else {
    $(".site-header").removeClass("scrolled");
  }

  // Animate elements based on scroll direction and position
  $(".fade-element").each(function (index) {
    const $element = $(this);
    const elementTop = $element.offset().top;
    const elementBottom = elementTop + $element.outerHeight();

    // Element is entering the viewport from below
    if (scrollingDown && elementTop < scrollTop + triggerPoint) {
      // Add small delay based on element index for cascade effect when scrolling down
      const delay = Math.min(index * 50, 300); // Cap delay at 300ms

      setTimeout(function () {
        $element.addClass("fade-in").removeClass("fade-out");
      }, delay);
    }
    // Element is leaving the viewport (scrolling up and element is below viewport)
    else if (!scrollingDown && elementTop > scrollTop + windowHeight) {
      $element.removeClass("fade-in").addClass("fade-out");
    }
    // Element is leaving the viewport (scrolling up and element is above viewport)
    else if (!scrollingDown && elementBottom < scrollTop) {
      $element.removeClass("fade-in").addClass("fade-out");
    }
    // Element is entering the viewport from above when scrolling up
    else if (!scrollingDown && elementBottom > scrollTop && elementTop < scrollTop + windowHeight) {
      $element.addClass("fade-in").removeClass("fade-out");
    }
  });
}

/**
 * Initialize all animation-related elements
 */
function initAnimations() {
  // Apply fade classes to elements
  const elementsToAnimate = [
    // Content sections
    ".section",
    ".top-section",
    ".video",
    ".why-vanbox",
    ".size",
    // Content blocks
    ".row",
    ".gallery",
    ".container > *:not(.site-header *) ",
    // Individual elements
    "h2",
    "h3",
    "h4",
    ".button",
    "img:not(.site-header img)",
  ];

  // Apply animation classes with different directions based on element type
  $(elementsToAnimate.join(", ")).each(function () {
    const $element = $(this);

    // Skip elements that are already in view on page load
    if ($element.offset().top > $(window).scrollTop() + $(window).height() * 0.8) {
      // Add different animation classes based on element type
      if ($element.is("h2, h3, h4")) {
        $element.addClass("fade-element fade-from-bottom");
      } else if ($element.is("img")) {
        $element.addClass("fade-element fade-from-side");
      } else if ($element.is(".button")) {
        $element.addClass("fade-element fade-from-bottom");
      } else {
        $element.addClass("fade-element");
      }
    }
  });

  // Add parallax effect to background images
  $("[class*='section']").each(function () {
    if ($(this).css("background-image") !== "none") {
      $(this).addClass("parallax-bg");
    }
  });
}

